<template>
  <div id="unassigned-events-cont" class="flex flex-col gap-2">
    <div
      v-if="noAvailabilityEvents.length"
      class="text-xxs text-gray-600 font-semibold"
    >
      NO AVAILABILITY
    </div>
    <div class="flex flex-col gap-2">
      <UnassignedEvent
        v-for="event in noAvailabilityEvents"
        :key="event.id"
        :event="event"
        :calendar="calendar"
      />
    </div>
    <div v-if="holdEvents.length" class="text-xxs text-gray-600 font-semibold">
      TEMPORARY HOLD
    </div>
    <div class="flex flex-col gap-2">
      <UnassignedEvent
        v-for="event in holdEvents"
        :key="event.id"
        :event="event"
        :calendar="calendar"
        ghost
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { initTippyTooltips } from "@/lib/helpers";

import { useEventCalendar } from "@/SchedulerV2/useEventCalendar";
import UnassignedEvent from "./UnassignedEvent.vue";

const { unassignedEvents, calendar } = useEventCalendar();

const holdEvents = computed(() =>
  unassignedEvents.value.filter((event) => event.ghost)
);
const noAvailabilityEvents = computed(() =>
  unassignedEvents.value.filter((event) => !event.ghost)
);

onMounted(() => {
  initTippyTooltips();
});
</script>
